import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ProctorConsentBanner = ({ onAccept }) => (
  <div className="proctor-consent-overlay">
    <div className="proctor-consent-card">
      <div className="proctor-consent-icon">
        <Icon name="Shield" size={22} />
      </div>
      <h2 className="proctor-consent-title">This interview is proctored</h2>
      <p className="proctor-consent-copy">
        Your camera, microphone, screen activity, and typing patterns may be monitored during this session to protect interview integrity.
        Alerts are shown to the interviewer only.
      </p>
      <ul className="proctor-consent-list">
        <li>Tab switches and paste events are tracked</li>
        <li>Camera may be analyzed for multiple faces or devices</li>
        <li>Attention patterns such as sustained looking away may be logged</li>
        <li>Background voices may trigger integrity alerts</li>
      </ul>
      <Button
        onClick={onAccept}
        className="proctor-consent-button"
        iconName="Check"
        iconPosition="left"
      >
        I understand, join room
      </Button>
    </div>
  </div>
);

export default ProctorConsentBanner;
